<template>
  <image-list :list="list" />
</template>

<script>
import ImageList from "@/components/ImageList.vue";

export default {
  name: "projekter",
  components: {
    ImageList
  },
  data() {
    return {
      list: [
        {
          id: 1,
          type: "LeftRight",
          leftImage: "/images/projekter/1/left.jpg",
          leftImageHeight: 450,
          rightImage: "/images/projekter/1/right.jpg",
          rightImageHeight: 450,
          leftText: "SOGNEHUS HOLMENS KIRKE KØBENHAVN 2008-11",
          rightText: ""
        },
        {
          id: 2,
          type: "2LeftRight",
          leftTopImage: "/images/projekter/2/left-top.jpg?v=1002",
          leftTopImageHeight: 200,
          leftBottomImage: "/images/projekter/2/left-bottom.jpg?v=1002",
          leftBottomImageHeight: 206,
          rightImage: "/images/projekter/2/right.jpg?v=1002",
          rightImageHeight: 200,
          leftText: "SOGNEHUS HOLMENS KIRKE KØBENHAVN 2008-11",
          rightText: ""
        },
        {
          id: 3,
          type: "LeftRight",
          leftImage: "/images/projekter/3/left.jpg",
          leftImageHeight: 370,
          rightImage: "/images/projekter/3/right.jpg",
          rightImageHeight: 370,
          leftText: "SOGNEBYGNING ”LINDEGÅRDEN” RIBE 2008-11",
          rightText: ""
        },
        {
          id: 4,
          type: "Center",
          centerImage: "/images/projekter/4/center.jpg",
          centerImageHeight: 450,
          leftText: "SOGNEBYGNING ”LINDEGÅRDEN” RIBE 2008-11",
          rightText: ""
        },
        {
          id: 5,
          type: "LeftRight",
          leftImage: "/images/projekter/5/left.jpg",
          leftImageHeight: 390,
          rightImage: "/images/projekter/5/right.jpg",
          rightImageHeight: 390,
          leftText:
            "NYBYGNING ”TIETGENS ÆRGRELSE” STORE KONGENSGADE KØBENHAVN 1992",
          rightText: ""
        },
        {
          id: 6,
          type: "LeftRight",
          leftImage: "/images/projekter/6/left.jpg",
          leftImageHeight: 330,
          rightImage: "/images/projekter/6/right.jpg",
          rightImageHeight: 330,
          leftText: "VAGTBYGNING MARSELISBORG SLOT AARHUS 2014-",
          rightText: ""
        }
      ]
    };
  }
};
</script>
